// Cart Custom JavaScript
document.addEventListener("DOMContentLoaded", function () {
  // Handle quantity select changes
  const quantitySelects = document.querySelectorAll(".quantity-select");

  quantitySelects.forEach((select) => {
    select.addEventListener("change", function (e) {
      // Prevent the built-in LineItemQuantity handler from firing
      e.stopPropagation();
      
      const lineKey = this.getAttribute("data-line-key");
      const quantity = parseInt(this.value);

      if (quantity < 1) {
        this.value = 1;
        return;
      }

      // Update cart via AJAX
      updateCartQuantity(lineKey, quantity, this);
    });
  });

  // Function to update cart quantity
  function updateCartQuantity(lineKey, quantity, selectElement) {
    const formData = new FormData();
    formData.append("id", lineKey);
    formData.append("quantity", quantity);

    fetch("/cart/change.js", {
      method: "POST",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        // Find the actual quantity that was set (Shopify may have adjusted it)
        const updatedItem = data.items.find(item => item.key === lineKey);
        if (!updatedItem) {
          console.warn("Item not found in cart response");
          window.location.reload();
          return;
        }
        
        const actualQuantity = updatedItem.quantity;
        
        // Update the select value to match what Shopify actually set
        if (selectElement) {
          // Update select options if inventory changed
          if (updatedItem.variant) {
            const variant = updatedItem.variant;
            if (variant.inventory_management && variant.inventory_policy === 'deny' && variant.inventory_quantity !== undefined) {
              // Calculate max: remaining inventory + current quantity in cart
              const maxQuantity = variant.inventory_quantity + actualQuantity;
              const currentMax = selectElement.querySelectorAll('option').length;
              
              // Add more options if needed (up to 20)
              if (maxQuantity > currentMax && maxQuantity <= 20) {
                for (let i = currentMax + 1; i <= maxQuantity; i++) {
                  const option = document.createElement('option');
                  option.value = i;
                  option.textContent = i;
                  selectElement.appendChild(option);
                }
              }
            }
          }
          
          // Set the actual quantity that Shopify accepted
          selectElement.value = actualQuantity.toString();
          
          // If the quantity was adjusted by Shopify, show a brief message
          if (actualQuantity !== quantity) {
            console.log(`Quantity adjusted from ${quantity} to ${actualQuantity} due to inventory limits`);
          }
        }
        
        // Update cart count in header if it exists
        const cartCount = document.querySelector(".cart-count");
        if (cartCount) {
          cartCount.textContent = data.item_count;
        }

        // Update cart totals without full page reload
        updateCartTotals(data);
      })
      .catch((error) => {
        console.error("Error updating cart:", error);
        // On error, reload to show correct state
        window.location.reload();
      });
  }
  
  // Function to update cart totals without page reload
  function updateCartTotals(cartData) {
    // Update total price if element exists
    const totalPriceElements = document.querySelectorAll('.cart-summary__total-price, .cart-sticky-checkout__price');
    totalPriceElements.forEach(el => {
      // Format money - you may need to adjust this based on your money format
      const formattedPrice = new Intl.NumberFormat('nl-NL', {
        style: 'currency',
        currency: 'EUR'
      }).format(cartData.total_price / 100);
      el.textContent = formattedPrice;
    });
    
    // Update subtotal if element exists
    const subtotalElements = document.querySelectorAll('.cart-summary__item');
    // You can add more specific updates here if needed
  }

  // Sticky checkout button functionality
  function handleStickyCheckout() {
    const stickyCheckout = document.getElementById("cart-sticky-checkout");
    const mainCheckoutButton = document.querySelector(
      '.cart-form button[type="submit"]'
    );

    if (!stickyCheckout || !mainCheckoutButton) return;

    function checkVisibility() {
      const mainButtonRect = mainCheckoutButton.getBoundingClientRect();
      const isMainButtonVisible =
        mainButtonRect.top < window.innerHeight && mainButtonRect.bottom > 0;

      if (isMainButtonVisible) {
        stickyCheckout.style.display = "none";
      } else {
        stickyCheckout.style.display = "block";
      }
    }

    // Check on scroll and resize
    window.addEventListener("scroll", checkVisibility);
    window.addEventListener("resize", checkVisibility);

    // Initial check
    checkVisibility();
  }

  // Initialize sticky checkout
  handleStickyCheckout();
});
